<template>
  <el-dialog title="修改密码" :visible.sync="showWindow" v-loading="loading" :before-close="beforeClose" width="600px">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPassword">
        <el-input type="password" v-model="form.oldPassword" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" :label-width="formLabelWidth" prop="password">
        <el-input type="password" v-model="form.password" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" :label-width="formLabelWidth" prop="passwordRepaeat">
        <el-input type="password" v-model="form.passwordRepaeat" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelWindow">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import MyAccount from 'api/myAccount'
const _myAccount = new MyAccount()

export default {
  props: {
    showWindow: Boolean
  },
  data () {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {
        oldPassword: '',
        password: '',
        passwordRepaeat: ''
      },
      formLabelWidth: '80px',
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        passwordRepaeat: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    cancelWindow() {
      this.$emit('closeWindow')
    },
    beforeClose() {
      this.$emit('closeWindow')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          this.modifyPassword()
        } else {
          return false
        }
      })
    },
    modifyPassword() {
      let { oldPassword, password, passwordRepaeat } = this.form
      this.loading = true
      _myAccount.modifyPassword(oldPassword, password, passwordRepaeat)
        .then(res => {
          this.loading = false
            this.$message({
              message: '密码修改成功',
              type: 'success',
              duration: 2000
            })
            oldPassword = ''
            password = ''
            passwordRepaeat = ''
            this.beforeClose()
        }).catch(err => {
                                this.loading = false
                                this.$message.error('修改失败');
                            })
                            .finally(_ => {
                                // this.loading.close();
                            });
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>
